<div class="toast-container" *ngIf="showToast">
    <alert [type]="toastData.type" class="alert-details">
        <p [innerHTML]="toastData.messageOne"></p>
        <button class="close-btn" [style]="toastData.type == 'success' ? 'color:#155724' : 'color:#ac0011'" (click)="closeToast()">✖</button>
    </alert>
</div>